var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResearchSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.067,
    height: 27.584,
    viewBox: "0 0 30.067 27.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;stroke:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.875 6.042)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.25,20.5a7.25,7.25,0,1,1,7.25-7.25A7.257,7.257,0,0,1,16.25,20.5Zm0-13.292a6.042,6.042,0,1,0,6.042,6.042A6.049,6.049,0,0,0,16.25,7.208Z",
    transform: "translate(-9 -6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.214 17.382)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.566,22.17a.607.607,0,0,1-.428-.176L18.56,16.416a.6.6,0,0,1,.854-.854l5.578,5.578a.6.6,0,0,1-.427,1.031Z",
    transform: "translate(-18.384 -15.385)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.146,2.208H.6A.6.6,0,0,1,.6,1H21.146a.6.6,0,1,1,0,1.208Z",
    transform: "translate(0 -1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25.375)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.146,23.208H.6A.6.6,0,0,1,.6,22H21.146a.6.6,0,0,1,0,1.208Z",
    transform: "translate(0 -22)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.042)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.271,7.208H.6A.6.6,0,1,1,.6,6h9.667a.6.6,0,1,1,0,1.208Z",
    transform: "translate(0 -6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 19.334)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.271,18.208H.6A.6.6,0,0,1,.6,17h9.667a.6.6,0,1,1,0,1.208Z",
    transform: "translate(0 -17)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12.688)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.854,12.708H.6A.6.6,0,1,1,.6,11.5h7.25a.6.6,0,1,1,0,1.208Z",
    transform: "translate(0 -11.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchSchoolIcon);
export default __webpack_public_path__ + "static/media/research-school-icon.a31bedf0e2b38c2260aa0f235d440ca9.svg";
export { ForwardRef as ReactComponent };